import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import Cursor from "./Components/Cursor/Cursor";
import CursorContextProvider from "./CursorContextProvider";

import AnimatedRoutes from "./Components/AnimatedRoutes";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <CursorContextProvider>
      <Cursor />
      <Router>
        <AnimatedRoutes />
      </Router>
    </CursorContextProvider>
  </React.StrictMode>
);
